module.exports = __webpack_public_path__ + "static/logo_HeroCs_d2_dsktp-1a032a647963d9a63c728702c0c471ec.png";